module.exports = __webpack_public_path__ + "static/img/icon_rjyf_rjfw_kf.800566e8.png";